export const tabs = {
  general: 'General',
  options: 'Options',
  actions: 'Actions',
  properties: 'Properties',
} as const
